import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { AuthService } from '../../auth/auth-service';
import { ProductFamily } from '../../opc-app/productfamily/productfamily.model';
import { ConfigService } from './configService';
import { ProductLine } from '../../opc-app/productline/productline.model';
import { Subject } from 'rxjs/Subject';
import { EnvironmentSettings } from '../models/environmentsettings.model';

@Injectable()
export class ProductService {
  productFamilies: ProductFamily[];
  productFamilyChange = new Subject<ProductFamily[]>();
  environmentSettings: EnvironmentSettings;
  constructor(private _http: HttpClient) {
    this.environmentSettings = new EnvironmentSettings();
  }

  getProductFamily() {
    this.productFamilyChange.subscribe((productFamilies: ProductFamily[]) => {
      this.productFamilies = productFamilies.filter(p => p.isActive);
    });
    let productFamilyImgs = this.productFamilies ? this.productFamilies.map(p => p.image).filter(function (e) { return (e != 'null' && e !== null && e != ''); }) : null;

    if (!this.productFamilies || (productFamilyImgs != undefined || productFamilyImgs != null || productFamilyImgs != [])) {
      return this._http.get(this.environmentSettings.apiEndPoint + 'api/productfamily/GetProductFamilies')
        .map((res: ProductFamily[]) => this.productFamilies = res);
    }
    return Observable.of(this.productFamilies);
  }
  getAllProductFamily(): Observable<any> {
    return this._http.get(this.environmentSettings.apiEndPoint + 'api/ProductFamily/GetAllProductFamilies');
  }
  getAllProductLines(): Observable<any> {
    return this._http.get(this.environmentSettings.apiEndPoint + 'api/productline/GetAllProductLines');
  }
  getProductLineById(id: number): Observable<any> {
    return this._http.get(this.environmentSettings.apiEndPoint + 'api/productline/GetProductLinesByProductFamilyId/' + id);
  }
  setProductFamilies(productFamilies: ProductFamily[]) {
    this.productFamilies = productFamilies.filter(p => p.isActive);
  }
  addOrUpdateProductFamily(productFamily: ProductFamily, file: any, isNew: boolean): Observable<any> {
    let urlPath = '';
    if (isNew) {
      urlPath = 'api/ProductFamily/AddProductFamily';
    } else {
      urlPath = 'api/ProductFamily/UpdateProductFamily';
    }
    const data = JSON.stringify(productFamily);
    const formData = new FormData();
    formData.append('productFamily', data);
    if (file) {
      formData.append('file', file, file.name);
    }
    return this._http.post(this.environmentSettings.apiEndPoint + urlPath, formData);
  }
  deleteProductFamily(item: number): Observable<any> {
    return this._http.post(this.environmentSettings.apiEndPoint + 'api/ProductFamily/DeleteProductFamily', item);
  }
  addOrupdateProductLine(productLine: ProductLine, file: any, isNew: boolean): Observable<any> {
    let urlPath = '';
    if (isNew) {
      urlPath = 'api/ProductLine/AddProductLine';
    } else {
      urlPath = 'api/ProductLine/UpdateProductLine';
    }
    const data = JSON.stringify(productLine);
    const formData = new FormData();
    formData.append('productLine', data);
    if (file) {
      formData.append('file', file, file.name);
    }
    return this._http.post(this.environmentSettings.apiEndPoint + urlPath, formData);
  }
  deleteProductLine(item: number): Observable<any> {
    return this._http.post(this.environmentSettings.apiEndPoint + 'api/productline/DeleteProductLine', item);
  }
  getLogo(): Observable<any> {
    return this._http.get(this.environmentSettings.apiEndPoint + 'api/Header/GetLogo');
  }

}



// WEBPACK FOOTER //
// ./src/opc/shared/services/product.service.ts